require('./httpTriggers.less');

class HttpTriggersController {
    promiseModel = {};
    downloadPrognosisReportForm;

    constructor(private toastService, private Imports){  }

    $onInit() { }

    importStockValue(year) {
        this.promiseModel['importStockValuePromise'] = this.Imports.importStock({year: year}).$promise.then(() => {
            this.toastService.showSimpleToast("Import vellykket", 3000);
            this.promiseModel['importStockValuePromise'] = undefined;
        }, (error) => {
            this.toastService.parseError(error);
            this.promiseModel['importStockValuePromise'] = undefined;
        })
    }

    importPrognosisNumbers(year, type) {
        this.promiseModel['importPrognosisNumbersPromise'] = this.Imports.importForecast({year: year, type: type}).$promise.then(() => {
            this.toastService.showSimpleToast("Import vellykket", 3000);
            this.promiseModel['importPrognosisNumbersPromise'] = undefined;
        }, (error) => {
            this.toastService.parseError(error);
            this.promiseModel['importPrognosisNumbersPromise'] = undefined;
        })
    }

    importCampaign(year) {
        this.promiseModel['importCampaignCodesPromise'] = this.Imports.importCampaignCodes({year: year}).$promise.then(() => {
            this.toastService.showSimpleToast("Import vellykket", 3000);
            this.promiseModel['importCampaignCodesPromise'] = undefined;
        }, (error) => {
            this.toastService.parseError(error);
            this.promiseModel['importCampaignCodesPromise'] = undefined;
        })
    }

    getPrognosisYear(year){
        if(!year){
            return "";
        }else{
            return year.toString();
        }
    }

}

class HttpTriggersOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcHttpTriggersController";
    public template: any = require('./httpTriggers.html');
}

rkcApp.controller("rkcHttpTriggersController", ['toastService', 'Imports', function(toastService, Imports){
    return new HttpTriggersController(toastService, Imports);
}])
    .component("rkcHttpTriggers", new HttpTriggersOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/httpTriggers/httpTriggers.ts
 **/